module.exports = __webpack_public_path__ + "img/licenseImg.42c919d9.png";